import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import {
  buildAttorneyValues,
  getAttorneyTotalReduction,
} from "../../helper/attorney";
import useAttorneySection from "../../hooks/useAttorneySection";
import { useSettlementStore } from "../../store/settlementStore";
import { SETTLEMENT_STYLES } from "../../style/styles";
import SettlementActionButtons from "../common/SettlementActionButtons";
import SettlementTextField from "../common/SettlementTextField";

import AttorneyTotalReductionCapsule from "./AttorneyTotalReductionCapsule";

export default function AttorneySection({ className = "" }) {
  const caseDetail = useSettlementStore((state) => state.caseDetail);
  const {
    formValues,
    isDirty,
    isEditing,
    isFeeEditing,
    isCostEditing,
    isSaving,
    canEditCaseSettlement,
    handleFieldChange,
    handleBeginFeeEdit,
    handleBeginCostEdit,
    handleClearFee,
    handleClearCost,
    handleCancel,
    handleSave,
  } = useAttorneySection({ caseDetail });
  const initialValues = buildAttorneyValues(caseDetail);
  const totalReduction = getAttorneyTotalReduction(
    isEditing ? formValues : initialValues,
    caseDetail
  );

  return (
    <section
      className={`flex min-h-[220px] flex-col justify-between rounded-[12px] p-4 shadow-sm ${className}`}
      style={SETTLEMENT_STYLES.sectionCard}
    >
      <div className="flex-1 flex flex-col gap-3">
        <div className="flex items-center gap-3">
          <Svg
            name={SvgEnum.HisLandmark}
            color={SETTLEMENT_STYLES.sectionIconColor}
            sx={SETTLEMENT_STYLES.sectionIcon}
          />
          <h3 className="text-lg font-semibold" style={SETTLEMENT_STYLES.sectionTitle}>
            Attorney
          </h3>
        </div>

        <div className="mt-2">
          <SettlementTextField
            label="Attorney's Fees"
            value={formValues.lawyerSettlementAmount}
            onChange={(event) => handleFieldChange("lawyerSettlementAmount", event.target.value)}
            placeholder="Enter attorney's fees"
            startAdornment="$"
            isEditable={isFeeEditing}
            showEditIcon={canEditCaseSettlement && !isFeeEditing}
            showClearIcon={canEditCaseSettlement && isFeeEditing}
            onEditClick={handleBeginFeeEdit}
            onDisplayClick={handleBeginFeeEdit}
            onClear={handleClearFee}
            canEdit={canEditCaseSettlement}
          />
        </div>

        <div className="mt-2">
          <SettlementTextField
            label="Attorney's Costs"
            value={formValues.lawyerSettlementCosts}
            onChange={(event) => handleFieldChange("lawyerSettlementCosts", event.target.value)}
            placeholder="Enter attorney's costs"
            startAdornment="$"
            isEditable={isCostEditing}
            showEditIcon={canEditCaseSettlement && !isCostEditing}
            showClearIcon={canEditCaseSettlement && isCostEditing}
            onEditClick={handleBeginCostEdit}
            onDisplayClick={handleBeginCostEdit}
            onClear={handleClearCost}
            canEdit={canEditCaseSettlement}
          />
        </div>
      </div>

      <div className="mt-4">
        <AttorneyTotalReductionCapsule value={totalReduction} />
      </div>

      {isEditing && canEditCaseSettlement ? (
        <div className="mt-1 flex">
          <SettlementActionButtons
            disableSave={isSaving || !isDirty}
            handleOnClickSaveButton={handleSave}
            disableCancel={isSaving}
            handleOnClickCancelBtn={handleCancel}
          />
        </div>
      ) : null}
    </section>
  );
}
